import React from "react";
import AcrossValue from "../components/Career/AcrossValue";
import JobListings from "../components/Career/JobListings";
import JobDetails from "../components/Career/JobDetails";
import banner1 from "../assets/Banner/WebBanner/b2.png";
import Header from "../layout/Header";
import HeroSection from "../components/HeroSection";

import logo from "../assets/images/About/about-logo.png";
import TeamsSection from "../components/AboutUs/TeamsSection";
import BenefitsOfJoiningUs from "../components/Career/BenefitsOfJoiningUs";

const Career = () => {
  return (
    <div>
      <HeroSection
        bannerImage={banner1}
        heading="Careers at Across Assist"
        description="Be part of a team that’s passionate about innovation and making a difference. At Across Assist, your ideas matter and your growth is our priority. Discover opportunities to learn, lead, and shape the future of protection. Join us—let’s build something meaningful together."
        image={logo}
        gradientBg="linear-gradient(268.53deg, #1363DF 28.18%, #000000 124.21%)"
        gradientOpacity={0.9}
      />

      <BenefitsOfJoiningUs />

      {/* <JobFilterComponent /> */}
      {/* <TeamsSection /> */}
      <AcrossValue />
      <JobListings />
    </div>
  );
};

export default Career;
